interface DisplayNamesOptions {
    localeMatcher?: 'lookup' | 'best fit';
    type: 'language' | 'region' | 'script' | 'currency';
    fallback?: 'code' | 'none';
  }
  
  declare namespace Intl {
    class DisplayNames {
      constructor(locales: string | string[], options: DisplayNamesOptions);
      of(code: string): string | undefined;
    }
  }
  

const getAllCountryNames = () => {
    const regionNames = new Intl.DisplayNames(['en'], { type: 'region' });
    // ISO 3166-1 alpha-2 codes for all countries
    const countryCodes = [
      "AD", "AE", "AF", "AG", "AI", "AL", "AM", "AO", "AR", "AT", "AU", "AW", "AZ",
      "BA", "BB", "BD", "BE", "BF", "BG", "BH", "BI", "BJ", "BN", "BO", "BR", "BS",
      "BT", "BW", "BY", "BZ", "CA", "CD", "CF", "CG", "CH", "CI", "CL", "CM", "CN",
      "CO", "CR", "CU", "CV", "CY", "CZ", "DE", "DJ", "DK", "DM", "DO", "DZ", "EC",
      "EE", "EG", "ER", "ES", "ET", "FI", "FJ", "FM", "FR", "GA", "GB", "GD", "GE",
      "GH", "GM", "GN", "GQ", "GR", "GT", "GW", "GY", "HN", "HR", "HT", "HU", "ID",
      "IE", "IL", "IN", "IQ", "IR", "IS", "IT", "JM", "JO", "JP", "KE", "KG", "KH",
      "KI", "KM", "KN", "KP", "KR", "KW", "KZ", "LA", "LB", "LC", "LI", "LK", "LR",
      "LS", "LT", "LU", "LV", "LY", "MA", "MC", "MD", "ME", "MG", "MH", "MK", "ML",
      "MM", "MN", "MR", "MT", "MU", "MV", "MW", "MX", "MY", "MZ", "NA", "NE", "NG",
      "NI", "NL", "NO", "NP", "NR", "NU", "NZ", "OM", "PA", "PE", "PG", "PH", "PK",
      "PL", "PT", "PW", "PY", "QA", "RO", "RS", "RU", "RW", "SA", "SB", "SC", "SD",
      "SE", "SG", "SI", "SK", "SL", "SM", "SN", "SO", "SR", "SS", "ST", "SV", "SY",
      "SZ", "TD", "TG", "TH", "TJ", "TL", "TM", "TN", "TO", "TR", "TT", "TV", "TZ",
      "UA", "UG", "US", "UY", "UZ", "VA", "VC", "VE", "VN", "VU", "WS", "YE", "ZA",
      "ZM", "ZW"
    ];
  
    // return countryCodes.map(code => {
    //     const countryName = regionNames.of(code);
    //     return { label: countryName, value: countryName };
    //   });
      return countryCodes.map(code => regionNames.of(code));
  }

export default getAllCountryNames;
  
  


// WEBPACK FOOTER //
// ./src/panels/catalog/cart/utils/countryName.ts